export interface BookingPage {
  internalLabel: string;
  link: string;
  publicName: string;
}

const bookingPageInitialValue: BookingPage = {
  internalLabel: "",
  link: "",
  publicName: "",
};

export default interface Schedules {
  bookingPage: BookingPage;
  cancelRescheduleLink: string;
  creationTime: string;
  durationMinutes: number;
  email: string;
  entryDate: string;
  firstName: string;
  joinUrl: string;
  lastName: string;
  owner: string;
  phone: string;
  scheduleId: string;
  scheduleStatus: number;
  startingTime: string;
  status: string;
  subject: string;
  userId: string;
}

const schedulesInitialValue: Schedules = {
  bookingPage: bookingPageInitialValue,
  cancelRescheduleLink: "",
  creationTime: "",
  durationMinutes: 0,
  email: "",
  entryDate: "",
  firstName: "",
  joinUrl: "",
  lastName: "",
  owner: "",
  phone: "",
  scheduleId: "",
  scheduleStatus: 0,
  startingTime: "",
  status: "",
  subject: "",
  userId: "",
};

export { schedulesInitialValue };
